import {Component, EventEmitter, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SuccessDialogComponent } from '../services/success-dialog.component';
import {AuthService} from "../services/auth.service";
import {FailureDialogComponent} from "../services/failure-dialog.component";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgIf
    ],
    styleUrls: ['./register.component.css']
})
export class RegisterComponent {
    registerForm: FormGroup;
    @Output() loginClicked = new EventEmitter<void>();
    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private router: Router,
        private authService: AuthService
    ) {
        this.registerForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required] }, { validators: this.passwordMatchValidator });
    }

    showPassword = false;
    showConfirmPassword = false;
    isPlacingOrder = false;

    togglePassword() {
        this.showPassword = !this.showPassword;
    }
    toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
    }

    passwordMatchValidator(form: FormGroup) {
        return form.get('password')?.value === form.get('confirmPassword')?.value
            ? null : { mismatch: true };
    }

    onRegister() {

        if (this.registerForm.valid) {
            this.isPlacingOrder = true;
            this.authService.register(this.registerForm.value).subscribe({
                next: () => {
                    this.isPlacingOrder = false;
                    const dialogRef  = this.dialog.open(SuccessDialogComponent, {
                        width: '400px',
                        data: {
                            title: 'Registration Successful',
                            message: 'Your registration was completed successfully.'
                        }
                    });
                    dialogRef.afterClosed().subscribe(() => {
                        this.loginClicked.emit();
                    });
                },
                error: (err) => {
                    this.isPlacingOrder = false;
                    const dialogRef = this.dialog.open(FailureDialogComponent, {
                        data: { message: err.error?.message || 'An unexpected error occurred.' }
                    });

                    dialogRef.afterClosed().subscribe(() => {
                        console.error('Registration failed:', err.error?.message || err.message);
                        // Optionally reset form or keep user on register page
                    });
                }

            });
        }
    }

}